import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { AsPropertyService } from 'src/app/core/services/as-property.service';
import { AsReflectionService } from 'src/app/core/services/as-reflection.service';
import { WarningComponent } from '../warning/warning.component';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;

  formFeedback: FormGroup;

  reflectionType: any[] = [];

  allReflectionType: any[] = [];

  fileNames: string[] = [];

  filesSize: number[] = [];

  serviceTypesFilterCtrl: FormControl = new FormControl()

  constructor(
    private reflectionSevice: AsReflectionService,
    private propertyService: AsPropertyService,
    public dialogRef: MatDialogRef<FeedbackComponent>,
    private fb: FormBuilder,
    private toast: ToastrService,
    private message: Message,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.initForm();
    this.getTypes();

    this.serviceTypesFilterCtrl.valueChanges.subscribe(() => {
      this.reflectionType = this.allReflectionType.filter(item => item.name.toLowerCase().includes(this.serviceTypesFilterCtrl.value.toLowerCase()))
    })
  }

  initForm() {
    this.formFeedback = this.fb.group({
      itemTypeId: new FormControl(null, Validators.required),
      title: new FormControl(null, Validators.required),
      contentFeedback: new FormControl(null, Validators.required),
      file: new FormControl(null),
    })
    this.formFeedback.controls.file.patchValue([]);
  }

  // get types
  getTypes() {
    this.propertyService.getTypesFeedback().subscribe(rs => {
      if (rs && rs.success) {
        this.allReflectionType = rs.data
        this.reflectionType = this.allReflectionType;
      }
    })
  }

  sendFeedback() {
    this.blockUI.start('');
    this.formFeedback.markAllAsTouched();
    if (this.formFeedback.invalid) {
      this.blockUI.stop();
      return;
    }

    const control = this.formFeedback.controls;

    const contentFeedback = control.contentFeedback.value.replace(/\n/g, '<br>');
    

    this.reflectionSevice.feedbackBase64(control.itemTypeId.value, control.title.value, contentFeedback, control.file.value)
      .then(res => {
        if (res.success) {
          this.toast.success(this.message.getMessage('reflection.title.sent'));
          this.dialogRef.close();
        } else {
          this.toast.error(res.message);
        }
        this.blockUI.stop();
      })
  }

  focusOut(field: string) {
    if (!this.formFeedback.controls[field].value) {
      return
    }
    const value = this.formFeedback.controls[field].value.trim();
    this.formFeedback.controls[field].patchValue(value);
  }

  onSelectedUpload(e) {
    const files = Array.from(e.target.files);
    const oldFiles = this.formFeedback.controls.file.value;
    const types = ['png', 'jpg', 'pdf'];

    if (files.length + oldFiles.length > 5) {
      this.toast.error(this.message.getMessage('reflection.errors.files_length'));
      return;
    }

    let newSize = 0, oldSize = 0, errorType = false;
    files.forEach((item: File) => {
      const split = item.name.split('.');

      if (!types.includes(split.pop())) {
        errorType = true;
      }

      newSize += item.size;
    })

    if (errorType) {
      this.toast.error(this.message.getMessage('reflection.errors.file_accept'));
      return;
    }

    oldFiles.forEach((item: File) => {
      oldSize += item.size;
    })



    if (newSize + oldSize > 5242880) {
      this.toast.error(this.message.getMessage('reflection.errors.files_size'));
      return;
    }

    setTimeout(() => {
      files.forEach((item: File) => {
        this.fileNames.push(this.checkmatched(this.fileNames, item.name));
        this.filesSize.push(item.size);
      })
    }, 0)

    this.formFeedback.controls.file.patchValue([...oldFiles, ...files]);
    e.target.value = null;
  }

  private checkmatched(listFileName: string[], name: string) {
    const filenameSplit = name.split('.')
    const type = filenameSplit.pop();
    const fileName = filenameSplit.join('.');
    let fileNameConverted = fileName + '.' + type;
    let k = 1;
    if (listFileName.length > 0) {
      while (listFileName.includes(fileNameConverted)) {
        fileNameConverted = fileName + '(' + k + ').' + type;
        k++;
      }
    }

    return fileNameConverted;
  }

  deleteFile(fileIndex) {
    this.blockUI.stop();
    const dialogRef = this.dialog.open(WarningComponent, {
      data: this.message.getMessage('reflection.title.confirm_delete')
    })

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        const files = this.formFeedback.controls.file.value;
        files.splice(fileIndex, 1);
        this.fileNames.splice(fileIndex, 1);
        this.filesSize.splice(fileIndex, 1);
        this.formFeedback.controls.file.patchValue(files);
      }
    })
  }

  close() {
    if (this.formFeedback.dirty) {
      const dialogRef = this.dialog.open(WarningComponent, {
      data: this.message.getMessage('messages.confirm_change_data')
      })

      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      })

      return
    }

    this.dialogRef.close();
  }
}
